import { ImageSource } from 'expo-image';
import { registerImages } from '@bonanza-social/moonlight';

import images from './images';

registerImages('shop', images);

declare global {
  interface RegisteredImages {
    shop: Record<keyof typeof images, ImageSource>;
  }
}
